import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/50"
            : "bg-gradient-to-b from-background-50/80 to-transparent"
        }`}
      >
        <div className="max-w-lg mx-auto px-4 h-14 flex items-center justify-between">
          <a href="#top" className="font-heading font-bold text-lg text-foreground-950 tracking-tight">
            kwai<span className="text-primary-500">.</span>ads
          </a>
          <a
            href="https://www.instagram.com/kwai.ads"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-background-100 border border-background-300/30 flex items-center justify-center text-foreground-600 hover:text-primary-400 transition-colors cursor-pointer"
          >
            <i className="ri-instagram-line text-lg"></i>
          </a>
        </div>
      </div>
    </header>
  );
}